import { buildOnboardingUrl } from "@workspace/dto/email/destinations";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import { defineEmailNotificationHandler } from "./types";

const UserOnboardingCompletionReminderSchema = z.object({
  recipientRole: z.enum(["employee", "employer"]),
  stage: z.number().int().min(1),
});

export const userOnboardingCompletionReminderHandler =
  defineEmailNotificationHandler({
    type: "user.onboarding_completion_reminder",
    icon: "application",
    title() {
      return "Finish setting up your account";
    },
    description() {
      return "Reminder to complete your VacWork account setup.";
    },
    schema: UserOnboardingCompletionReminderSchema,
    buildEmailPayload(data, recipient, { baseUrl, unsubscribeUrl }) {
      return {
        name: "email/user.onboarding_completion_reminder",
        data: {
          userId: recipient.userId,
          to: recipient.email,
          from: buildFromAddress(),
          recipientName: recipient.name,
          recipientRole: data.recipientRole,
          stage: data.stage,
          onboardingUrl: buildOnboardingUrl(baseUrl),
          unsubscribeUrl,
        },
      };
    },
  });
